import React, {useState} from 'react'
import {ColumnDef, ColumnPinningState} from '@tanstack/react-table'
import IndeterminateCheckbox from '../components/Table/IndeterminateCheckbox'
import {TableTemplateCSS} from '../components/Table/TableCSS'
import TableTemplate from '../components/Table/TableTemplate'
import {Link} from 'react-router-dom'
import OverlayTrigger from 'react-bootstrap/esm/OverlayTrigger'
import popover from '../components/Popover'
import {KTSVG} from '../../../_metronic/helpers'
import {useConfigSystemSettingsStore} from './Config-System-Settings-Store'
import {Config_System_Settings_Filter} from './Config-System-Settings-Filter'

export default function Config_System_Settings_List() {
  //Table Related
  const [rowSelection, setRowSelection] = React.useState({})
  const [totalCount, setTotalCount] = useState(0)
  const [columnVisibility, setColumnVisibility] = React.useState({})
  const [columnPinning, setColumnPinning] = useState<ColumnPinningState>({
    left: ['select'],
    right: ['action'],
  })
  const [pagination, setPagination] = useState({
    pageIndex: 0, //initial page index
    pageSize: 200, //default page size
  })
  const [showMetrics, setShowMetrics] = useState(false)

  //Table Related

  //Zustand Store
  const filterOptions = useConfigSystemSettingsStore((state: any) => state.filterOptions)
  const getData = useConfigSystemSettingsStore((state: any) => state.getData)
  const setFilterOptions = useConfigSystemSettingsStore((state: any) => state.setFilterOptions)
  const setGetData = useConfigSystemSettingsStore((state: any) => state.setGetData)

  //States
  // const [selectedRowData, setSelectedRowData] = useState<any>([
  //   {
  //     walletAccName: '',
  //     merchantTimestamp: '',
  //     depositStatusUpdateDT: '',
  //     merchantTxnId: '',
  //     submittedTxnId: '',
  //     depositFee: '',
  //     merchantName: '',
  //     reference: '',
  //     approvalRejectionRemark: '',
  //     matchStatus: '',
  //     srcWalletAcc: '',
  //     depositDT: '',
  //     depositProcessId: '',
  //     id: '',
  //     customerCd: '',
  //     merchantCd: '',
  //     successBy: '',
  //     amount: '',
  //     walletAccNo: '',
  //     adjustmentRemark: '',
  //     completedDT: '',
  //     agentName: '',
  //     mobileNo: '',
  //     walletCd: '',
  //     callbackStatus: '',
  //     matchedTransTxnId: '',
  //     depositStatus: '',
  //   },
  // ])
  const [loading, setLoading] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [formData, setFormData] = useState<any>([])

  //   const spinnerStyle = {
  //     border: '4px solid rgba(0, 0, 0, 0.3)',
  //     borderTop: '4px solid #3498db',
  //     borderRadius: '50%',
  //     width: '40px',
  //     height: '40px',
  //     animation: 'spin 1s linear infinite',
  //     margin: 'auto',
  //   }

  //   const spinKeyframes = `
  //   @keyframes spin {
  //     0% { transform: rotate(0deg); }
  //     100% { transform: rotate(360deg); }
  //   }
  // `
  const columns = React.useMemo<ColumnDef<any>[]>(
    () => [
      {
        id: 'select',
        size: 50,
        header: ({table}) => (
          <IndeterminateCheckbox
            {...{
              checked: table.getIsAllRowsSelected(),
              indeterminate: table.getIsSomeRowsSelected(),
              onChange: table.getToggleAllRowsSelectedHandler(),
            }}
          />
        ),
        cell: ({row}) => (
          <div
            className='px-1'
            style={{
              backgroundColor: 'transparent',
            }}
          >
            <IndeterminateCheckbox
              {...{
                checked: row.getIsSelected(),
                disabled: !row.getCanSelect(),
                indeterminate: row.getIsSomeSelected(),
                onChange: row.getToggleSelectedHandler(),
              }}
            />
          </div>
        ),
      },
      {
        header: 'ID',
        accessorKey: 'id',
        cell: (info) => info.getValue(),
        enableColumnFilter: false,
      },
      {
        header: 'Name',
        accessorKey: 'name',
        cell: (info: any) => info.getValue(),
        enableColumnFilter: false,
        size: 250,
      },
      {
        header: 'Description',
        accessorKey: 'description',
        cell: (info: any) => info.getValue(),
        enableColumnFilter: false,
      },
      {
        header: 'Status',
        accessorKey: 'active',
        cell: (info) => (info.getValue() == true ? 'ACTIVE' : 'INACTIVE'),
        enableColumnFilter: false,
      },
      {
        header: 'Create DateTime',
        accessorKey: 'createdAt',
        cell: (info: any) => {
          return info.getValue().replace('T', ' ').replace(/\.\d+/, '')
        },
        enableColumnFilter: false,
        size: 200,
      },
      {
        header: 'Update DateTime',
        accessorKey: 'updatedAt',
        cell: (info: any) => {
          if (info.getValue() === undefined) {
            return ''
          }
          return info.getValue().replace('T', ' ').replace(/\.\d+/, '')
        },
        enableColumnFilter: false,
        size: 200,
      },
      {
        header: 'Action',
        cell: (info: any) => {
          return (
            <Link
              to={`/config-system-settings/edit/${info.row.original.id}`}
              state={info.row.original}
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
              onClick={() => {
                setGetData(true)
              }}
            >
              <OverlayTrigger trigger='hover' placement='top' overlay={popover('Edit')}>
                <div
                  style={{
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                  }}
                >
                  <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                </div>
              </OverlayTrigger>{' '}
            </Link>
          )
        },
        enableColumnFilter: false,
      },
    ],
    []
  )

  return (
    <div>
      <div className='d-flex justify-content-between mb-5'>
        <div className='m-0'></div>
      </div>{' '}
      {/* <CustCodeBlackListCreateModal loading={loading} setLoading={setLoading} /> */}
      <Config_System_Settings_Filter setFormData={setFormData} />
      <TableTemplateCSS>
        <TableTemplate
          data={formData}
          columns={columns}
          rowSelection={rowSelection}
          setRowSelection={setRowSelection}
          columnPinning={columnPinning}
          columnVisibility={columnVisibility}
          setColumnVisibility={setColumnVisibility}
          showMetrics={showMetrics}
          manualPagination={true}
          pagination={pagination}
          setPagination={setPagination}
          totalCount={totalCount}
        />
      </TableTemplateCSS>
    </div>
  )
}
